import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { type FormFieldComponentProps } from "@/lib/types/types";

export const LastNameComponent = ({
  value,
  isErrored,
  onChange,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("lastName")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="lastName"
      autoComplete="family-name"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "lastNamePlaceholder" })}
      label={<FormattedHTMLMessage id="lastName" defaultMessage="Last name" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidLastName" defaultMessage="Invalid last name" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      disabled={disabled}
    />
  );
};
